import '../../styles/signup.css';

interface SignupLayoutProps {
  children: React.ReactNode;
}

export const SignupLayout = ({ children }: SignupLayoutProps) => {
  return (
    <div className="relative z-10 w-full min-h-screen flex items-stretch">
      {children}
    </div>
  );
};
